import { motion } from 'motion/react';

import { cn } from '@/lib/utils';

import Badge from '@/decodo/components/atoms/badge';

import { getPrettyProductLabel } from './helpers';

import { returnRefAndGenerateDataTracker } from '@/components/atoms/button/utils';
import { Target } from './constants/targets';
import { TargetIcon } from './TargetIcon';

type ScraperHeaderTargetOptionProps = {
  target: Target;
  isSelected: boolean;
  handleSelect: (target: Target) => void;
};

export const ScraperHeaderTargetOption = ({
  target,
  isSelected,
  handleSelect,
}: ScraperHeaderTargetOptionProps) => {
  const productLabel = getPrettyProductLabel(target)?.replace(/_/g, ' ');

  return (
    <motion.button
      type='button'
      key={target.name}
      variants={listItemVariants}
      className='w-full cursor-pointer px-6 py-3 hover:bg-gray-100'
      data-tracker-context={`target-${target.label}`}
      onClick={() => handleSelect(target)}
      ref={(_ref) => {
        returnRefAndGenerateDataTracker(_ref, null);
      }}
    >
      <div className='flex items-center gap-x-2'>
        <TargetIcon target={target} />
        <p
          className={cn(
            'font-medium text-gray-950',
            isSelected && 'text-brand-600'
          )}
        >
          {target.label}
        </p>
        {!!productLabel && (
          <Badge
            size='s'
            variant='filled'
            colors='gray-300'
            classNames={{ root: 'pointer-events-none text-gray-700' }}
          >
            {productLabel}
          </Badge>
        )}
      </div>
    </motion.button>
  );
};

const listItemVariants = {
  open: {
    opacity: 1,
    y: 0,
  },
  closed: { opacity: 0, y: -10 },
};
